export const rowClass = data => {
    const classe = {};

    const todosStatus = {
        Cancelado: 'row-cancelado',
        PRE: 'row-precontrato',
        Ativo: 'row-ativo',
        Suspenso: 'row-suspenso',
        Recusado: 'row-recusado'
    };

    classe[todosStatus[data.Status]] = true;

    return classe;
};
